import React, { useCallback, useState, useRef, useMemo } from "react";
import MaterialReactTable from "material-react-table";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import { getListCommandeSage, getCommentaireCmd } from "../../Redux/commandeReduce";
import { getLivCommande } from "../../Redux/livraisonReduce";
import { getGrossisteSite } from "../../Redux/grossisteReduce";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import { verification } from "../../Redux/usersReduce";
import { useTranslation } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import LivraisonEtatCell from "./LivraisonEtatCell";
import Configuration from "../../configuration";
import ImprimerCmdMedis from "./ImprimerfactureProMedis";

function ListCommandeValider({ obj, client }) {

  let lang = window.localStorage.getItem("lang");


  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useHistory();
  var token = localStorage.getItem("x-access-token");
  var annee = localStorage.getItem("annee");
  localStorage.removeItem("bonification");
  var decoded = jwt_decode(token);
  var idUser = decoded.id;
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const [grossisteSite, setGrossisteSite] = useState({});
  const [data2, setData2] = useState([]);
  const [alert, setAlert] = useState(null);

  const dateLivraisonRef = useRef(null);
  const dateLivraisonAFCRef = useRef(null);

  const idRole = useRef(obj.user.id_role);
  const commentaireRef = useRef(null);


  const [columns2] = useState([
    {
      id: "numero",
      header: t("num_order"),
      accessorKey: "NumCommande",
    },
    {
      id: "Reference_app",
      header: t("Réf Commande en ligne"),
      accessorKey: "Reference_app",
    },
    {
      id: "date",
      header: t("date_cmd"),
      accessorKey: "DateCommande",
      Cell: ({ cell }) => (
        <div className="block_action">
          {cell.row.original.DateCommande !== null
            ? new Date(cell.row.original.DateCommande)
              .toISOString()
              .slice(0, 10)
            : ""}
        </div>
      ),
    },
    {
      id: "date_livraison",
      header: "Date Livraison",
      accessorKey: "DateLivraison",
      Cell: ({ cell }) => (
        <div className="block_action">
          {cell.row.original.DateLivraison !== null
            ? new Date(cell.row.original.DateLivraison)
              .toISOString()
              .slice(0, 10)
            : ""}
        </div>
      ),
    },
    {
      id: "montant_total",
      header: t("montant_total") + " HT",
      accessorKey: "MontantHT_TND",
      Cell: ({ cell }) => {
        const value = parseFloat(cell.row.original.MontantHT_TND) || 0;
        return (
          <div className="block_action">
            {new Intl.NumberFormat('fr-FR', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            }).format(value)}
          </div>
        );
      }
    },
    {
      id: "Reference",
      header: t("Reference"),
      accessorKey: "RefCommande",
    },

    {
      id: "Livraison",
      header: t("Etat de livraison"),
      accessorKey: "Livraison",
      Cell: ({ cell }) => (
        cell.row.original.Livraison ? cell.row.original.Livraison : cell.row.original.Livraison
      ),
    },
    {
      id: "Reference_app",
      header: t("Commande insérée"),
      accessorKey: "Reference_app",
      Cell: ({ cell }) => (
        cell.row.original.Reference_app && cell.row.original.Reference_app.trim() != "" && cell.row.original.Reference_app != null ?
          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              detailCommandeRef(cell.row.original.Reference_app);
              localStorage.setItem(
                "file",
                cell.row.original.namefile
              );
              localStorage.setItem(
                "id_user",
                cell.row.original.id_user
              );
            }}
            className="btn btn-info"
            title={t("details")}
          >
            {cell.row.original.Reference_app}
          </Button> : null
      ),
    },
    {
      id: "visualization",
      header: t("visualization"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.NumCommande}
          onClick={(e) => {
            detailCommande(cell.row.original.NumCommande);
          }}
          className="btn btn-info"
          title={t("details")}
        >
          <i className="fas fa-eye"></i>
        </Button>
      ),
    },
    {
      id: "bon_liv",
      header: t("Bon_de_livraison"),
      accessorKey: "",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.NumCommande}
          onClick={(e) => {
            detailLivraison(cell.row.original.NumCommande);
          }}

          className="btn btn-info  "
          title={t("details")}
        >
          <i className="fas fa-info"></i>
        </Button>
      ),
    },
  ]);

  const columnsAfc2 = useMemo(() => [
    {
      id: "numero",
      header: t("num_order"),
      accessorKey: "NumCommande",
    },
    {
      id: "Reference_app",
      header: t("Réf Commande en ligne"),
      accessorKey: "Reference_app",
    },
    {
      id: "grossiste",
      header: "Code " + t("Wholesaler"),
      accessorKey: "Client",
    },
    {
      id: "grossiste",
      header: t("Wholesaler"),
      accessorKey: "RaisonSocial",
    },
    {
      id: "date",
      header: t("date_cmd"),
      accessorKey: "DateCommande",
      Cell: ({ cell }) => (
        <div className="block_action">
          {cell.row.original.DateCommande !== null
            ? new Date(cell.row.original.DateCommande)
              .toISOString()
              .slice(0, 10)
            : ""}
        </div>
      ),
    },
    {
      id: "date_livraison",
      header: "Date Livraison",
      accessorKey: "DateLivraison",
      Cell: ({ cell }) => (
        <div className="block_action">
          {cell.row.original.DateLivraison !== null
            ? new Date(cell.row.original.DateLivraison)
              .toISOString()
              .slice(0, 10)
            : ""}
        </div>
      ),
    },
 {
      id: "montant_total",
      header: t("montant_total") + " HT",
      accessorKey: "MontantHT_TND",
      Cell: ({ cell }) => {
        const value = parseFloat(cell.row.original.MontantHT_TND) || 0;
        return (
          <div className="block_action">
            {new Intl.NumberFormat('fr-FR', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            }).format(value)}
          </div>
        );
      }
    },
    {
      id: "Reference",
      header: t("Reference"),
      accessorKey: "RefCommande",
    },
    {
      id: "Livraison",
      header: t("État de livraison"),
      accessorKey: "Livraison",
      Cell: ({ cell }) => {
        const livraison_map = {
          1: "Non livrée",
          2: "Partiellement livrée",
          3: "Livrée",
        };
        return livraison_map[cell.row.original.Livraison] || "-";
      },
    },
    {
      id: "bon_liv",
      header: t("Bon_de_livraison"),
      accessorKey: "",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.NumCommande}
          onClick={(e) => {
            detailLivraison(cell.row.original.NumCommande);
          }}

          className="btn btn-info  "
          title={t("details")}
        >
          <i className="fas fa-eye"></i>
        </Button>
      ),
    },
    {
      id: "Reference_app",
      header: t("Commande insérée"),
      accessorKey: "Reference_app",
      Cell: ({ cell }) => (
        cell.row.original.Reference_app && cell.row.original.Reference_app.trim() != "" && cell.row.original.Reference_app != null ?
          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              detailCommandeRef(cell.row.original.Reference_app);
              localStorage.setItem(
                "file",
                cell.row.original.namefile
              );
              localStorage.setItem(
                "id_user",
                cell.row.original.id_user
              );
            }}
            className="btn btn-info"
            title={t("details")}
          >
            {cell.row.original.Reference_app}
          </Button> : null
      ),
    },
    {
      id: "visualization",
      header: t("visualization"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.NumCommande}
          onClick={(e) => {
            detailCommande(cell.row.original.NumCommande);
          }}

          className="btn btn-info  "
          title={t("details")}
        >
          <i className="fas fa-eye"></i>
        </Button>
      ),
    },
  ], [t]);



  function ListTable2({ list, loader }) {
    return (
      idRole.current != 6 ?
        <MaterialReactTable
          columns={columnsAfc2}
          data={list}
          enableColumnActions={true}
          enableColumnFilters={true}
          enablePagination={true}
          enableSorting={true}
          enableBottomToolbar={true}
          enableTopToolbar={true}
          muiTableBodyRowProps={{ hover: false }}
          displayColumnDefOptions={{
            'mrt-row-numbers': {
              size: 10,
            },
            'mrt-row-expand': {
              size: 10,
            },
          }}
          enableColumnFilterModes
          initialState={{
            columnVisibility: { description: false },
            density: 'compact',
            showGlobalFilter: true,
          }}

          filterFns={{
            myCustomFilterFn: (row, id, filterValue) => {
              const value = row.getValue(id);
              return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
            },
          }}
          globalFilterFn="myCustomFilterFn"

          muiSearchTextFieldProps={{
            placeholder: t("search"),
            sx: { minWidth: '18rem' },
            variant: 'outlined',
          }}
          localization={
            lang === "fr"
              ? MRT_Localization_FR
              : MRT_Localization_EN
          }
          state={{ isLoading: loader }}
        />
        :
        <MaterialReactTable
          state={{ isLoading: loader }}
          columns={columns2}
          data={list}
          enableColumnActions={true}
          enableColumnFilters={true}
          enablePagination={true}
          enableSorting={true}
          enableBottomToolbar={true}
          enableTopToolbar={true}
          muiTableBodyRowProps={{ hover: false }}
          displayColumnDefOptions={{
            'mrt-row-numbers': {
              size: 10,
            },
            'mrt-row-expand': {
              size: 10,
            },
          }}
          enableColumnFilterModes
          initialState={{
            columnVisibility: { description: false },
            density: 'compact',
            showGlobalFilter: true,
          }} muiSearchTextFieldProps={{
            placeholder: t("search"),
            sx: { minWidth: '18rem' },
            variant: 'outlined',
          }}
          localization={
            lang === "fr"
              ? MRT_Localization_FR
              : MRT_Localization_EN
          }
        />
    );

  }

  const verifToken = useCallback(async () => {
    var response = await dispatch(verification());
    if (response.payload === false) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      //setIdRole(response.payload.id_role)
    }
  }, [dispatch]);


  const hideAlert = () => {
    setAlert(null);
  };

  const getCommentaire = async (idCmd) => {
    var commentaires = await dispatch(getCommentaireCmd({ idCmd }));
    var commentaireElements = commentaires.payload.map((element, index) => (
      (element.commentaire && element.commentaire !== "") ? (
        <li key={index}>
          <strong>{element.users.nom_prenom}</strong>: {element.commentaire} <strong className="date-comment">{new Date(element.createdAt).toISOString().split('T')[0]}</strong>
        </li>
      ) : null
    ));
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        onConfirm={() => hideAlert()}
        cancelBtnBsStyle="danger"
      >
        <h3 className="alert-title">{t("comment")}</h3>
        <ul>{(commentaireElements.length == 1 && (commentaireElements[0] == null || commentaireElements[0] == "")) || (commentaireElements.length == 2 && (commentaireElements[0] == null || commentaireElements[0] == "") && (commentaireElements[1] == null || commentaireElements[1] == "")) ? t("aucun_comment") : commentaireElements}</ul>
      </SweetAlert>
    );
  };





  const fectchListCommande = useCallback(async (idUser, client) => {
    setLoader(true);
    try {
      // Using Promise.all to fetch commands and handle multiple async calls concurrently
      await Promise.all([
        dispatch(getListCommandeSage({ id_user: idUser, etat: 2, annee, client })).then((list) => {
          const res = list.payload;
          console.log(list)
          const array = [];
          const array2 = [];
          res.forEach((element) => {
            array.push(element);
          });
          console.log(array)
          setLoader(false);
          setData(array);
          setData2(array);
        }),
        // Add other async calls if needed
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  }, [dispatch, annee, idUser]);


  function detailCommande(idCmd) {
    navigate.push(client + "/detailsCmdSage/" + idCmd);
  }

  function detailCommandeRef(ref) {
    navigate.push(client + "/detailsCmdRef/" + ref);
  }

  function detailLivraison(idCmd) {
    dispatch(getLivCommande(idCmd)).then((e) => {
      if (e.payload.id_livraison) {
        navigate.push(client + "/detailsLivraison/" + e.payload.id_livraison);
      } else {
        notify(2, t("non_livré"));
      }
    });

  }
  function handleGrossisteSite(client) {
    dispatch(getGrossisteSite({ id_site: client == Configuration.industrie2 ? 2 : 3 })).then((e) => {
      setGrossisteSite(e.payload)
    });

  }



  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  React.useEffect(() => {
    verifToken()
    const fetchData = async () => {

      if (idRole.current > 0) {

        fectchListCommande(idUser, client);
      }
    };
    if(obj.user.id_role != 6 )handleGrossisteSite(client)
    fetchData();
  }, []);

  return (
    <>

      <Container fluid>
        {alert}
        <ToastContainer />
        {idRole.current == 6 || idRole.current == 5 || idRole.current == 1 ? <Row>
          {/* <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("my_orders")}</Card.Title>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable list={data} loader={loader} ></ListTable>

              </Card.Body>
            </Card>
          </Col> */}
        </Row> : null}

        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("my_orders")} </Card.Title>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable2 list={data2} loader={loader} ></ListTable2>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListCommandeValider;
